import { render, staticRenderFns } from "./BoardAssignmentsCard.vue?vue&type=template&id=5e744702&scoped=true&"
import script from "./BoardAssignmentsCard.vue?vue&type=script&lang=js&"
export * from "./BoardAssignmentsCard.vue?vue&type=script&lang=js&"
import style0 from "./BoardAssignmentsCard.vue?vue&type=style&index=0&id=5e744702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e744702",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VCol,VRow,VSimpleTable})
